<template>
  <v-container fluid>
    <v-card flat class="disable-scrollbars">
      <v-card-text>
        <v-row style="max-height: 20px">
          <v-col
            class="text-center mt-n3"
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xs="12"
          >
            <h1
              class="font-weight-bold blue-grey--text"
              style="text-transform: uppercase; font-size: 16px"
            >
              {{ title }}
            </h1>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: {
      type: String,
      require: true
    }
  }
};
</script>

<style scoped></style>
